// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"de8de892","241":"5d699384","381":"5e05beb5","643":"a656655c","962":"f32aff7e"}[chunkId] + ".chunk.js";
};